import React, { useMemo, useState ,useEffect} from "react";
import "./Trail.css";
import DoughnutLinearChart from "../DoughnutLinearChart/DoughnutLinearChart";
import apex from "../../images/apex-traits.svg";
import force from "../../images/force-traits.svg";
import bal from "../../images/balanced.svg";
import fli from "../../images/flicker.svg";
import mas from "../../images/mask-group.svg";
import HexgonChart from "../HexgonChart/HexgonChart";
import PopupOne from "../PopupOne/PopupOne";
import { IMG_URL} from "../../config";
import ll from "../../images/yellow-loc.svg";

function Trail({PopupContent,demension,token,testdata,tierData,showlock,UnLockModal,setUnLockModal,onLoginChange}) {


const [mile, setMile]  = useState(true);

const [trait_tiers, settrait_tiers]  = useState(tierData?.trait_tiers);

const [trait_label, settrait_label]  = useState(tierData?.title_content);

    useEffect(() => {
      if (tierData?.trait_tiers) {
        settrait_tiers(tierData?.trait_tiers);
      }

      if (tierData?.title_content) {
        settrait_label(tierData?.title_content);
      }
    }, [tierData]);

    const traits = useMemo(() => {


      if (!testdata?.data?.length) return [];

      return testdata.data.map((item) => {
        const leftLabel = item.resultcategory?.left_label || "";
        const rightLabel = item.resultcategory?.right_label || "";

        const label =
          item.letter === "left" ? leftLabel : rightLabel;

        const value = Math.round(
          item.letter === "left"
            ? parseFloat(item.left_result)
            : parseFloat(item.right_result)
        );

        const content_left = item.resultcategory?.label_content || "";
        const content_right = item.resultcategory?.label_content_right || "";

        const color_left_1 = item.resultcategory?.left_label_one || "";

        const color_left_2 = item.resultcategory?.left_label_two || "";

        const color_right_1 = item.resultcategory?.right_label_one || "";

        const color_right_2 = item.resultcategory?.right_label_two || "";

        const content = item.letter === "left" ? content_left : content_right;

        const bg_color_1 = item.letter === "left" ? color_left_1 : color_right_1;

        const bg_color_2 = item.letter === "left" ? color_left_2 : color_right_2;

        const showlock = item.resultcategory?.show_lock || false;
       
        return { label, value ,content,bg_color_1,bg_color_2,showlock};
      });
    }, [testdata]);

    // const getTierName = (value) => {
    //     if (value >= 81) return "Apex";
    //     if (value >= 61) return "Force";
    //     if (value >= 41) return "Balanced";
    //     if (value >= 21) return "Flicker";
    //     return "Whisper";
    // };

    const sortedTiers = useMemo(() => {
      if (!trait_tiers?.length) return [];

      return [...trait_tiers].sort(
        (a, b) => b.percentage - a.percentage
      );
    }, [trait_tiers]);

    const getTierName = (value) => {
      if (!sortedTiers.length) return null;

      for (let i = 0; i < sortedTiers.length; i++) {
        if (value >= sortedTiers[i].percentage) {
          return sortedTiers[i].tier_name;
        }
      }

      return sortedTiers[sortedTiers.length - 1].tier_name;
    };


  return (
    <div className="test-main1 test-main2">
      <div className="dough-bar">
        <div className="row">
          <div className="col-md-6">
            <div className="graph-wrapper">
              <div className="dough-title">
                <h6>{trait_label?.trait_degree_title}</h6>
              </div>
    
               {traits.map((trait, index) => {

                    const tierName = getTierName(trait.value);
                    const tierInfo = trait_tiers?.find(
                      (t) => t.tier_name === tierName
                    );
                    return (
                      <DoughnutLinearChart
                        key={index}
                        value={trait.value}
                        label={trait.label}
                        subLabel={tierInfo?.title || tierName}
                        description={trait?.content || ""}
                        tierName={tierName}
                        TriatData={tierInfo}
                        bg_color_1={trait?.bg_color_1}
                        bg_color_2={trait?.bg_color_2}
                        showlock={showlock && trait?.showlock}
                        UnLockModal={UnLockModal}
                        setUnLockModal={setUnLockModal}
                      />
                    );
                })}
            </div>
          </div>
          <div className="col-md-6">
            <div className="hexagraph-wrapper">
              <div className="hexa">

                <HexgonChart traits={traits} tierData={trait_tiers} trait_map_title={trait_label?.trait_map_title} trait_count_title={trait_label?.trait_count_title} />
              </div>



              <div className="icon-card">
                <div className="mini-tile">
                  <h6>{trait_label?.trait_title}</h6>

                  <p>{trait_label?.trait_description}</p>
                  
                </div>

                  <div className="full-list">

                    {trait_tiers?.map((tier) => (
                      <div key={tier.id} className="icon-cards">

                        <div className="left-icon">
                          <span>
                            <img src={`${IMG_URL}/d0/${tier?.trait_icon}`} alt="" />
                          </span>
                          <span>{tier.title}</span>
                        </div>

                        <div className="right-text">
                          <img src={`${IMG_URL}/d0/${tier?.trait_icon}`} alt="" />
                          <p
                            dangerouslySetInnerHTML={{
                              __html: tier.short_title,
                            }}
                          />
                        </div>

                      </div>
                    ))}

                  </div>
              </div>
            </div>
          </div>

            {token ? (
          <div className="home-overaly-btn">
                  <button className="overlay-btn triat-results-btn"

                      onClick={() => setUnLockModal(true)}

                      style={{'--trait_overlay_button':demension?.dimension_color?.trait_overlay_button,
                              '--trait_overlay_button_hover':demension?.dimension_color?.trait_overlay_button_hover,
                              '--luminus_button_color_15': `color-mix(in srgb, ${demension?.dimension_color?.trait_overlay_button} 15%, white)`,
                              '--luminus_button_color_25': `color-mix(in srgb, ${demension?.dimension_color?.trait_overlay_button} 25%, white)`,
                              '--luminus_button_color_38': `color-mix(in srgb, ${demension?.dimension_color?.trait_overlay_button} 38%, white)`,
                              '--luminus_button_color_45': `color-mix(in srgb, ${demension?.dimension_color?.trait_overlay_button} 45%, white)`,
                              '--luminus_button_color_50': `color-mix(in srgb, ${demension?.dimension_color?.trait_overlay_button} 50%, white)`,
                              '--luminus_button_color_55': `color-mix(in srgb, ${demension?.dimension_color?.trait_overlay_button} 55%, white)`,
                              '--luminus_button_color_70': `color-mix(in srgb, ${demension?.dimension_color?.trait_overlay_button} 70%, white)`,
                              '--luminus_button_color_85': `color-mix(in srgb, ${demension?.dimension_color?.trait_overlay_button} 85%, white)`,
                              '--luminus_button_color_92': `color-mix(in srgb, ${demension?.dimension_color?.trait_overlay_button} 92%, white)`,
                              '--luminus_button_color_100': demension?.dimension_color?.trait_overlay_button,
                            }}
                          
                  >
                      <span>{PopupContent?.trait_unlock_overlay_button}</span>
                      <span>
                      <img src={ll} alt="" />
                      </span>

                  </button>
                  </div>
              ):(
                <div className="home-overaly-btn home-overaly-btn-condition">

                    <button className="overlay-btn triat-results-btn"
                        onClick={() => onLoginChange(true)}

                          style={{'--trait_overlay_button':demension?.dimension_color?.trait_overlay_button,
                            '--trait_overlay_button_hover':demension?.dimension_color?.trait_overlay_button_hover,
                            '--luminus_button_color_15': `color-mix(in srgb, ${demension?.dimension_color?.trait_overlay_button} 15%, white)`,
                            '--luminus_button_color_25': `color-mix(in srgb, ${demension?.dimension_color?.trait_overlay_button} 25%, white)`,
                            '--luminus_button_color_38': `color-mix(in srgb, ${demension?.dimension_color?.trait_overlay_button} 38%, white)`,
                            '--luminus_button_color_45': `color-mix(in srgb, ${demension?.dimension_color?.trait_overlay_button} 45%, white)`,
                            '--luminus_button_color_50': `color-mix(in srgb, ${demension?.dimension_color?.trait_overlay_button} 50%, white)`,
                            '--luminus_button_color_55': `color-mix(in srgb, ${demension?.dimension_color?.trait_overlay_button} 55%, white)`,
                            '--luminus_button_color_70': `color-mix(in srgb, ${demension?.dimension_color?.trait_overlay_button} 70%, white)`,
                            '--luminus_button_color_85': `color-mix(in srgb, ${demension?.dimension_color?.trait_overlay_button} 85%, white)`,
                            '--luminus_button_color_92': `color-mix(in srgb, ${demension?.dimension_color?.trait_overlay_button} 92%, white)`,
                            '--luminus_button_color_100': demension?.dimension_color?.trait_overlay_button,
                          }}

                        > 
                        <span>{PopupContent?.trait_unlock_overlay_button}</span>
                        <span>
                            <img src={ll} alt="" />
                        </span>

                    </button>
                  </div>
              )} 

        </div>
      </div>
    </div>
  );
}

export default Trail;
